module.exports = __webpack_public_path__ + "static/img/buzaiceB.1e89704.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/buzaiceB.png
// module id = nroN
// module chunks = 2